import { useContext } from "react"
import { FeatureFlagsContext } from "./FeatureFlagsProvider"
import { FeatureFlags } from "./types"

/**
 * @returns An object whose keys are feature flags and values are booleans which determine whether or not the flags are enabled.
 */
export function useFlags(): FeatureFlags {
  const context = useContext(FeatureFlagsContext)

  if (!context) {
    throw new Error("useFlags must be used within a FeatureFlagsProvider component.")
  }

  return context
}
